import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  Eyebrow,
  Title,
  TextLoop,
  Span,
  SubTitle,
  CTAGroup,
  PrimaryRow,
  SecondaryRow,
  PrimaryButton,
  SecondaryButton,
  TextLinkButton,
} from "./HeroStyle";
import HeroImg from "../../images/HeroImage.jpg";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";

const HeroSection = () => {
  return (
    <div id="about">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>

        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Eyebrow>Senior Software Engineer</Eyebrow>

            <Title>{Bio.name}</Title>

            <TextLoop>
              <span>I build</span>
              <Span>
                <Typewriter
                  options={{
                    strings: [
                      "Distributed Systems",
                      "Real-Time Collaboration",
                      "Digital Infrastructure",
                      "Scalable SaaS Platforms",
                    ],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>

            <SubTitle>{Bio.description[0]}</SubTitle>
            <SubTitle>{Bio.description[1]}</SubTitle>

            <CTAGroup>
              <PrimaryRow>
                <PrimaryButton
                  href={Bio.storyPokerLive}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View StoryPoker
                </PrimaryButton>

                <SecondaryButton
                  href={Bio.cv}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download CV
                </SecondaryButton>
              </PrimaryRow>

              <SecondaryRow>
                <TextLinkButton
                  href={Bio.github}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub
                </TextLinkButton>

                <TextLinkButton
                  href={Bio.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </TextLinkButton>
              </SecondaryRow>
            </CTAGroup>
          </HeroLeftContainer>

          <HeroRightContainer id="Right">
            <Img src={HeroImg} alt="Valentyn Arkho portrait" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
